/**
 * Mixin for managing race manipulations queue (Vue 2 compatible)
 */
export default {
  data() {
    return {
      pendingManipulations: [],
    }
  },
  
  computed: {
    hasChanges() {
      return this.pendingManipulations.length > 0
    },
    
    changesCount() {
      return this.pendingManipulations.length
    },
  },
  
  methods: {
    addManipulation(type, data) {
      this.pendingManipulations.push({
        type: type,
        data: data,
        timestamp: new Date().toISOString(),
      })
    },
    
    removeManipulation(index) {
      if (index >= 0 && index < this.pendingManipulations.length) {
        this.pendingManipulations.splice(index, 1)
      }
    },
    
    clearManipulations() {
      this.pendingManipulations = []
    },
    
    getManipulationTypeLabel(type) {
      const labels = {
        virtual_reading: 'Виртуальное считывание',
        reassign: 'Переназначение',
        checkpoint_time: 'Время чекпоинта',
        status: 'Статус',
        time_constraints: 'Ограничения времени',
      }
      
      return labels[type] || type
    },
    
    getManipulationDetails(manipulation) {
      const data = manipulation.data
      
      switch (manipulation.type) {
        case 'status':
          return 'Участник ' + data.userId + ' → ' + data.status.toUpperCase()
        
        case 'checkpoint_time':
          return 'Участник ' + data.userId + ', ' + data.point + ' → ' + data.time
        
        case 'virtual_reading':
          return 'Участник ' + data.userId + ', ' + data.point + ' @ ' + data.timestamp
        
        case 'reassign':
          return 'Считывание ' + data.readingKey + ': ' + data.fromUserId + ' → ' + data.toUserId
        
        default:
          return JSON.stringify(data)
      }
    },
  },
}

